<div class="panel-container">
    <div class="panel-title-wrapper">
        <div class="panel-title">
            {{ 'Channel Overview' }}
        </div>
    </div>
    <div class="overview-container">
        <div *ngFor="let category of changes" class="category-container">
            <div
                [ngClass]="{
                    added: isAddedElement(category.status),
                    deleted: isDeletedElement(category.status),
                    unedited: isUneditedElement(category.status),
                }">
                {{ category.name }}
            </div>
            <div *ngFor="let group of category.groups" class="group-container">
                <div
                    [ngClass]="{
                        added: isAddedElement(group.status),
                        deleted: isDeletedElement(group.status),
                        unedited: isUneditedElement(group.status),
                    }">
                    {{ group.name }}
                </div>
                <div *ngFor="let channel of group.channels" class="channel-container">
                    <div
                        [ngClass]="{
                            added: isAddedElement(channel.status),
                            deleted: isDeletedElement(channel.status),
                            unedited: isUneditedElement(channel.status),
                        }">
                        {{ channel.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
